<div class="packages">
  <ng-container
    *ngIf="licensePackagesError || isLoadingLicensePackages; else tools"
  >
    <span *ngIf="licensePackagesError" class="danger"
      >Could not fetch packages</span
    >
    <app-loading-spinner *ngIf="isLoadingLicensePackages"></app-loading-spinner>
  </ng-container>
  <ng-template #tools>
    <ng-container *ngIf="!openEdit">
      <span class="section-heder">Current license package</span>
      <app-account-package
        [attr.bootstrap-status]="licenseBootstrapState"
        [package]="licensePackage?.displayName"
        [licenses]="licensePackage?.licenses"
        [innerId]="'currentPackage-' + licensePackage.code"
        [selected]="accountDetails.licensePackage === licensePackage?.code"
      >
      </app-account-package>
    </ng-container>
    <app-select-order-field
      *ngIf="openEdit"
      [title]="'Change license package'"
      [leftFieldlabel]="'New license package'"
      [valueToUpdate]="'licensePackage'"
      [buttonTooltip]="
        slimPackageNotEnabled
          ? 'You have to be an order manager to update Account license package'
          : ''
      "
      [disableTooltip]="
        disablePackage
          ? 'License bootstrap in progress or failed. License package management temporarily disabled. Refresh the page'
          : !hasOrderManagerRole
          ? 'Back Office role Order Manager required for managing license packages'
          : 'Disabled for an unknown reason. Contact support for resolve this'
      "
      [canPlaceOrders]="canPlaceOrders"
      [isUpdatingInput]="isUpdatingUserSeats"
      [options]="packageOptions"
      [inputValue]="accountDetails?.licensePackage"
      [hasWawRole]="hasWawRole"
      [disableFields]="disablePackage || !hasOrderManagerRole"
      [fullRowInput]="true"
      [useCancelButton]="true"
      (cancelEdit)="openEdit = false"
      (editInput)="openEdit = false; updatePackage($event)"
    ></app-select-order-field>
    <button
      *ngIf="!openEdit"
      class="edit btn btn-link"
      (click)="openEdit = true"
    >
      <i class="fas fa-pencil-alt"></i> Edit
    </button>
  </ng-template>
  <div class="quotas">
    <span class="section-header">Account limits</span>
    <p class="warning">
      <i class="fa fa-exclamation-triangle"></i> When changing the license
      package you may need to adjust the account limits.
    </p>
    <p>
      Each <i>license package</i> has the corresponding default
      <i>account limits (quotas)</i> defined in
      <a target="_blank" rel="noopener noreferrer" [href]="sharePointUrl"
        >this document</a
      >.
    </p>
    <p>
      When you changed the license package you also need to adjust the account
      limits on the
      <a routerLink="/au/accounts/{{ accountId }}" fragment="detail"
        >Details
      </a>
      tab. Unless otherwise negotiated and agreed with the customer, use the
      defaults defined in
      <a target="_blank" rel="noopener noreferrer" [href]="sharePointUrl"
        >this document</a
      >.
    </p>
    <p>
      Back Office does not adjust the account limits when changing the license
      package.
    </p>
  </div>
</div>
<div class="about">
  <div class="deprecation">
    <h5>New license packages 2025</h5>
    <p>We're working on streamlining APSIS One license packages.</p>
    <ul>
      <li><i>Lite</i> is deprecated. Use <i>Send</i> instead.</li>
      <li><i>Essential</i> is deprecated. Use <i>Automate</i> instead.</li>
      <li><i>All in one</i> is deprecated. Use <i>Grow</i> instead.</li>
    </ul>
    <p>
      Creating new accounts using the deprecated license packages will be
      blocked. Existing accounts will gradually be migrated.
    </p>
    <p>
      More details in
      <a target="_blank" rel="noopener noreferrer" [href]="sharePointUrl"
        >this document</a
      >.
    </p>
  </div>
  <span class="section-header">About feature toggles</span>
  <p>
    <i>Feature toggles</i> and <i>licenses</i> are one and the same. They are
    the exchangeable terms.
  </p>
  <p>
    Feature toggles (or licenses) can be used to enable one of the following
    most notable groups on the account level:
  </p>
  <ul>
    <li>Tools (1st class APSIS One tools)</li>
    <li>Features (lesser features)</li>
    <li>Account settings (configurable options)</li>
    <li>Integrations (managed by the Integrations Team)</li>
  </ul>
  <p>
    Individual feature toggles for this account can be managed on the
    <a routerLink="/au/accounts/{{ accountId }}" fragment="feature-toggles"
      >Feature toggles </a
    >tab.
  </p>
  <span class="section-heder">About license packages</span>
  <p>
    License packages are templates for new and existing accounts. They contain
    individual licenses.
  </p>
  <p>
    Features from within a package get
    <b>enabled when an account is created</b> using a specific package or when a
    specific package is applied to an existing account.
  </p>
  <p>
    When an existing account is switched from one package to another using the
    feature on the left, the features included in the current package but not in
    the new one are <b>turned off</b> and their related activities are also
    disabled. Features enabled via a license package cannot be disabled
    individually.
  </p>
  <span class="section-heder">More information</span>
  <p>
    <a target="_blank" rel="noopener noreferrer" [href]="sharePointUrl"
      >This document</a
    >
    provides the up to date information about the contents of each license
    package supported by APSIS One as well as the features enabled by default
    for any new account.
  </p>
</div>
